import {defineStore} from 'pinia'
import {config} from "@/core/config";
import {SmartSearchConfig} from "@/main";
import {searchLogger} from "@/core/Logger";


export const usePopularProductsStore = defineStore('PopularProductsStore', {
  state: () => {
    return {
      popularProducts: [],
      customPopularProduct: null as null | undefined | string
      
    }
  },
  getters: {
    getTopProduct(state) {
      return !!window?._QONizer?.customSmartSearchConfig?.promotedProductId && !!state.customPopularProduct
        ? state.customPopularProduct
        : state.popularProducts[0]
    },
    getPopularProducts(state) {
      return state.popularProducts.slice(0, SmartSearchConfig.value.onfocus.popularProducts.count)
    },
    getPopularProductsWithoutFirst(state) {
      return state.popularProducts.slice(1, SmartSearchConfig.value.onfocus.popularProducts.count + 1)
    }
  },
  actions: {
    async fetch(query: string | null = null) {
      const data = new FormData()
      data.append('s', SmartSearchConfig.value.onfocus.popularProducts.sortName)
      if (query) {
        data.append('q', query)
      }
      return await fetch(
        `https://${config.apiHost}/restapi/${config.customerSymbol}/search/${config.searchId}/products`,
        {
          method: 'POST',
          headers: {
            'Api-key': config.apiKey,
          },
          credentials: 'include',
          body: data,
        }
      )
    },
    
    async fetchCustomPopularProduct() {
      if (!window?._QONizer?.customSmartSearchConfig?.promotedProductId) {
        return
      }
      searchLogger.log(`Getting Custom TopProduct: ${window?._QONizer?.customSmartSearchConfig?.promotedProductId}`)
      try {
        const customPopularProduct = await this.fetch(window?._QONizer?.customSmartSearchConfig?.promotedProductId)
        if (customPopularProduct.ok) {
          const data = await customPopularProduct.json()
          const {products} = data
          searchLogger.log('Received Custom Top Product', JSON.stringify(products[0]))
          this.customPopularProduct = products[0]
        }
      } catch (e) {
        console.error('Error retrieving custom TOP PRODUCT:', e)
      }
    },
    
    async fetchPopularProducts() {
      try {
        
        const popularProductsResponse = await this.fetch()
        if (popularProductsResponse.ok) {
          const data = await popularProductsResponse.json()
          const {products} = data
          this.popularProducts = products
        }
        await this.fetchCustomPopularProduct()
        
      } catch (error) {
        console.error('Error retrieving search results:', error)
      }
    }
    
  },
})